import React from "react";


const ProductListEmptyState = () => {
    return (
        <div className='d-flex align-items-center justify-content-center pr-20 pl-20' style={{height: '55vh'}}>
            <div className='mobile-subtitle-regular cl-subtitle'>
                برای این دسته بندی محصولی وجود ندارد.
            </div>
        </div>
    )
}

export default ProductListEmptyState